import { isString } from 'utils/check';

export type EmailNotVerifiedPayload = {
  code: 'email_not_verified' | 'email_verification_expired';
  message: string;
  email?: string;
  email_sent?: boolean;
  can_resend?: boolean;
  can_change_email?: boolean;
  retry_after?: number;
};

function readDetail(error: unknown): unknown {
  if (!error || typeof error !== 'object') return undefined;
  const axiosError = error as { response?: { data?: { detail?: unknown } } };
  return axiosError.response?.data?.detail;
}

export function parseEmailNotVerifiedError(error: unknown): EmailNotVerifiedPayload | null {
  const detail = readDetail(error);
  if (!detail || typeof detail !== 'object' || Array.isArray(detail)) {
    return null;
  }
  const payload = detail as { code?: unknown; message?: unknown; email?: unknown };
  if (payload.code !== 'email_not_verified' && payload.code !== 'email_verification_expired') {
    return null;
  }
  return {
    code: payload.code,
    message: isString(payload.message) ? payload.message : 'Подтвердите email перед входом.',
    email: isString(payload.email) ? payload.email : undefined,
    email_sent: Boolean((payload as { email_sent?: unknown }).email_sent),
    can_resend: (payload as { can_resend?: unknown }).can_resend !== false,
    can_change_email: (payload as { can_change_email?: unknown }).can_change_email !== false,
    retry_after: Number((payload as { retry_after?: unknown }).retry_after) || undefined,
  };
}

export function parsePasswordNotSetError(error: unknown): {
  message: string;
  phone_otp_available?: boolean;
  phone?: string;
} | null {
  const detail = readDetail(error);
  if (!detail || typeof detail !== 'object' || Array.isArray(detail)) {
    return null;
  }
  const payload = detail as {
    code?: unknown;
    message?: unknown;
    phone_otp_available?: unknown;
    phone?: unknown;
  };
  if (payload.code !== 'password_not_set') return null;
  return {
    message: isString(payload.message)
      ? payload.message
      : 'Пароль еще не задан, войдите по коду или задайте его в профиле.',
    phone_otp_available: Boolean(payload.phone_otp_available),
    phone: isString(payload.phone) ? payload.phone : undefined,
  };
}
